import { keepPreviousData } from '@tanstack/react-query'

import useQuery from '@shared/hooks/src/useQuery'
import API from '@shared/services/src/API'
import { QK } from '@shared/utils'

export function useProviderCBOs(providerId, query = {}, options = {}) {
  return useQuery({
    queryKey: QK.providers.id(providerId).cbos.list(query),
    queryFn: () => API.providers.id(providerId).cbos.list(query),
    placeholderData: keepPreviousData,
    ...options,
  })
}
